import React, { useState, useEffect } from 'react';
import './DashboardPage.css';
import dashboardApi from '../../../services/apiServices/dashboardApi';
import { addMonths, endOfMonth, format, isAfter, isSameMonth, startOfMonth, subMonths } from "date-fns";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../../services/redux/loadingSlice';
import { ptBR } from 'date-fns/locale';

const DashboardPage = () => {
    const [metrics, setMetrics] = useState({});
    const [currentMonth, setCurrentMonth] = useState(new Date());
    const startDate = format(startOfMonth(currentMonth), "yyyy-MM-dd");
    const endDate = format(isSameMonth(currentMonth, new Date()) ? new Date() : endOfMonth(currentMonth),"yyyy-MM-dd");
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchMetrics = async () => {
            dispatch(setLoading(true));
            
            try {
                const metricsData = await dashboardApi.getMetrics({ startDate, endDate });
                setMetrics(metricsData);
            } catch (error) {
                console.error("Erro ao buscar métricas:", error);
                toast.error('Erro ao buscar os dados!');
            } finally {
                dispatch(setLoading(false));
            }
        };

        fetchMetrics();
    }, [startDate, dispatch, endDate]);

    const handlePreviousMonth = () => {
        setCurrentMonth(prev => subMonths(prev, 1));
    };

    const handleNextMonth = () => {
    const next = addMonths(currentMonth, 1);
    if (!isAfter(next, new Date())) {
        setCurrentMonth(next);
    }
    };

    const formatLabel = (itens) => {
        return itens.map(i => 
        {
            const parsedDate = new Date(i);
  
            if (isNaN(parsedDate.getTime())) {
              return '';
            }
          
            // Format day, month, and year
            const day = String(parsedDate.getDate()).padStart(2, '0');
            const month = String(parsedDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = parsedDate.getFullYear();

            return `${day}/${month}/${year}`;
        });
    }

    if (!metrics.QuantityOrdersPerDay) {
        return <div className="dashboard-container">Carregando...</div>;
    }


    const chartLabels = formatLabel(Object.keys(metrics.QuantityOrdersPerDay));
    const chartValues = Object.values(metrics.QuantityOrdersPerDay);
    const chartData = {
        labels: chartLabels,
        datasets: [
            {
                label: "Pedidos",
                data: chartValues,
                backgroundColor: "#1E293B",
                borderColor: "#1E293BE5",
                borderWidth: 1,
            },
        ],
    };

    return (
        <div className="container-admin-page">
            <h1>Dashboard</h1>
            <div className="dashboard-filter">
                <button className="month-button" onClick={handlePreviousMonth}>←</button>
                <span className="selected-month">
                    {format(currentMonth, "MMMM yyyy", { locale: ptBR })}
                </span>
                <button className="month-button" onClick={handleNextMonth}>→</button>
            </div>
            <div className="dashboard-summary">
                <div className="summary-card">
                    Total de Pedidos: <strong>{metrics.QuantityOrders}</strong> {/* Número total de pedidos registrados */}
                </div>
                <div className="summary-card">
                    Pedidos Permitidos para Pagamento: <strong>{metrics.QuantityOrdersAllowPayment}</strong> {/* Quantidade de pedidos permitidos para pagamento */}
                </div>
                <div className="summary-card">
                    Pedidos Aguardando Pagamento: <strong>{metrics.QuantityOrdersWaitPayment}</strong> {/* Quantidade de pedidos aguardando pagamento */}
                </div>
                <div className="summary-card">
                    Pedidos Pagos: <strong>{metrics.QuantityOrdersPaid}</strong> {/* Quantidade de pedidos pagos */}
                </div>
                <div className="summary-card">
                    Pedidos Cancelados pelo Cliente: <strong>{metrics.QuantityOrdersCanceledCustomer}</strong> {/* Quantidade de pedidos cancelados pelos clientes */}
                </div>
                <div className="summary-card">
                    Pedidos Cancelados pela Loja: <strong>{metrics.QuantityOrdersCanceledStore}</strong> {/* Quantidade de pedidos cancelados pela loja */}
                </div>
                <div className="summary-card">
                    Pedidos Expirados: <strong>{metrics.QuantityOrdersExpired}</strong> {/* Quantidade de pedidos expirados */}
                </div>
                <div className="summary-card">
                    Pedidos em Análise: <strong>{metrics.QuantityUnderAnalysis}</strong> {/* Quantidade de pedidos em análise */}
                </div>
                <div className="summary-card">
                    Transações Concluídas: <strong>{metrics.QuantityTransactionsOk}</strong> {/* Quantidade de transações concluídas com sucesso */}
                </div>
                <div className="summary-card">
                    Transações não Concluídas: <strong>{metrics.QuantityTransactionsNotOk}</strong> {/* Quantidade de transações não concluídas */}
                </div>
                <div className="summary-card">
                    E-mails Enviados: <strong>{metrics.QuantityMailsSent}</strong> {/* Quantidade de e-mails enviados */}
                </div>
                <div className="summary-card">
                    Total de Clientes: <strong>{metrics.QuantityClients}</strong> {/* Número total de clientes cadastrados */}
                </div>
            </div>
            <div className="dashboard-chart">
                <h2>Pedidos por Dia</h2>
                <Bar data={chartData} />
            </div>
        </div>
      );
};

export default DashboardPage;
